import Parseable from '@/misc/Parseable';

export interface PromoterRates {
    perDriver: number,
    perCustomer: number
}

export interface PromoterIncentive {
    /** One-time bonus paid to a promoter when a referred driver is created. */
    signupBonus: number,
    /** Fee per passenger on every commissionable ride. */
    perPassengerRate: number,
    /**
     * When the incentive model went live. null means it is not live yet and
     * nothing accrues at all -- neither bonuses nor commission, and not
     * retroactively for existing drivers or rides.
     */
    effectiveFrom: string | null
}

/**
 * The fare-suggestion settings the driver app pre-fills a new offer's price
 * with. Every amount is a decimal (1.50 is a valid value), never an integer.
 */
export interface Pricing {
    /** flat amount on every ride before distance and time, N$ */
    baseFare: number,
    /** per kilometre of the trip, N$ */
    perKm: number,
    /** per minute of estimated travel time, N$ */
    perMinute: number,
    /** flat booking fee once per ride, N$ */
    bookingFee: number,
    /**
     * Taken off a shared ride's total, as a PERCENTAGE from 0 to 100:
     * 40 means 40 % off. Never a fraction such as 0.40.
     */
    sharedDiscountPercent: number
}

export default class ShareConfiguration extends Parseable {
    public id!: string;
    public pricePerRide!: number;
    public pricePerRideActive!: boolean;
    public driverWaitingTimeMin?: number;
    public promoterRates?: PromoterRates;
    public promoterIncentive?: PromoterIncentive;
    /** Absent on a backend that does not know the block yet; complete on one that does. */
    public pricing?: Pricing;
    public updatedAt!: string;

    public static parseFromObject(object: Partial<ShareConfiguration>): ShareConfiguration {
        const config = new ShareConfiguration();
        Object.assign(config, object);

        return config;
    }

    public parseToObject(): Partial<ShareConfiguration> {
        const tmp = { ...this };
        return tmp;
    }
}
